import { i18n } from './instance.js';
import { resolveLocale } from './locales.js';
import { NAMESPACES } from './namespaces.js';
/**
 * Resolve the copy function for an account's practice type. Backend entry point:
 * resolve once per operation (e.g. per PDF render), then pass the CopyFn down.
 * A future language axis adds a `language` field to the options bag.
 */
export function getCopy(opts) {
    // Pass every namespace explicitly (`NAMESPACES` is a literal `as const`
    // tuple, so the namespace names stay literal types rather than widening to
    // `string[]`) so a fully-qualified key (`invoice:pdf.x`, `glossary:x`,
    // `activity:x`, `account:x`, `chat:x`, `project:x`, `errors:x`, `allocation:x`) type-checks
    // regardless of which one is the default - omitting `ns` here would fix the
    // returned TFunction to the default namespace only, and reject every
    // `ns:key` call to the other namespaces.
    return i18n.getFixedT(resolveLocale(opts.practiceType), NAMESPACES);
}
